import { render, staticRenderFns } from "./ContestEdit.vue?vue&type=template&id=136db0ae&"
import script from "./ContestEdit.vue?vue&type=script&lang=js&"
export * from "./ContestEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports